export function dialog_report(state = {}, action) {
  if (action.type === 'SHOW_DIALOG_REPORT') {
    return action.data;
  }
  if (action.type === 'CLOSE_DIALOG_REPORT') {
    return action.data;
  }
  return state;
}
